import Ajv from "ajv";

export const validateServiceParameter = (
  param: unknown,
  schema: object
): boolean => {
  const ajv = new Ajv();
  const validate = ajv.compile(schema);
  return validate(param);
};
